import * as types from "./types";

function obtenerListaActividades(payload) {
  return { type: types.FETCH_LISTA, payload };
}

function resetListaActividades() {
  return { type: types.RESET };
}

function obtenerDetalleActividad(payload) {
  return { type: types.FETCH_DETALLE, payload };
}
function resetDetalleActividad() {
  return { type: types.RESET_DETALLE };
}

/*---*/
export {
  obtenerListaActividades,
  resetListaActividades,
  obtenerDetalleActividad,
  resetDetalleActividad
};



// WEBPACK FOOTER //
// ./src/ducks/actividades/actions.js